/**
 * @file useDefaultCountry
 * Hook that provides the operator's default country code for phone inputs
 */

import { useOperator } from "./useOperator";

function useDefaultCountry(): string {
  const { operator } = useOperator();

  return operator?.settings?.operatingCountryCode?.toLowerCase() || "us";
}

export { useDefaultCountry };
